import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { showSuccessToast } from "../../../assets/toastUtils";
import userimage from "../../../assets/new-images/user.svg";
import logoutIcon from "../../../assets/new-images/logout.png";

// import "./AccountDetailDropdown.css"

function NewAgentAccountDetailDropdown({ name, userType, handleLogout }) {
  const navigate = useNavigate();
  const [loginDetails, setLoginDetails] = useState(false);
  const [logOutPopup, setLogOutPopup] = useState(false);

  const handleOnClickLogIn = (e) => {
    // e.preventDefault();
    e.stopPropagation();
    setLoginDetails(!loginDetails);
  };

  const { id } = useParams();

  const userName = localStorage.getItem("userName");
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const token = localStorage.getItem("token");
  // console.log(userDetails);

  const accountDetailsRef = useRef(null);
  const accountLoginRef = useRef(null);

  // Function to handle clicks outside the account details div
  const handleClickOutside = (event) => {
    //   if (accountDetailsRef.current && !accountDetailsRef.current.contains(event.target)) {
    //     setAccountDetails(false);
    //   }
    if (
      accountLoginRef.current &&
      !accountLoginRef.current.contains(event.target)
    ) {
      setLoginDetails(false);
    }
  };

  useEffect(() => {
    // Attach the click event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Cleanup the event listener on component unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogoutHandle = () => {
    localStorage.clear();
    // window.location.reload();
    // handleLogout();
    navigate("/");
    showSuccessToast("Logged Out Successful");
  };
  const [agentDetails, setAgentData] = useState();

  const fetchAgentDetails = (token) => {
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/user-profile`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setAgentData(data.data);
        if (data.success) {
          if (!data?.data?.name || !data?.data?.email || !data?.data?.phone) {
            return navigate("/agent-account");
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching agent details:", error);
      });
  };

  useEffect(() => {
    if (token && userType === "agent") {
      fetchAgentDetails(token);
    }
  }, [token]);

  return (
    <>
      <Link
        to={`/agent-account`}
        // onClick={handleOnClickLogIn}
        className="NewSearch-Login"
        ref={accountLoginRef}
      >
        <div style={{ position: "relative" }}>
          <button
            style={{ textTransform: "capitalize" }}
            className="Header-logbtn flex align_items_center justify_content_end flex_gap_10"
            id="vendorLogin"
          >
            {/* <img src={userimage} className="user_image" /> */}


            <div className="profile_name_div">{agentDetails?.name?.charAt(0)}</div>


            {/* Hi, {agentDetails?.name || "User"}{'  '} */}
            Hi,{" "}
            {agentDetails?.name
              ? agentDetails?.name.length > 5
                ? agentDetails?.name.slice(0, 5) + "..."
                : agentDetails?.name
              : "User"}
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="7"
              viewBox="0 0 12 7"
              fill="none"
              style={{
                transition: "transform 0.5s",
                marginLeft: "5px",
                transform: loginDetails ? "rotate(180deg)" : "rotate(0deg)",
              }}
            >
              <path d="M11 1L6 6L1 1" stroke="#333333" strokeWidth="1.2" />
            </svg> */}
            {loginDetails}
          </button>

          {loginDetails && (
            <div
              className="accountDetails"
              ref={accountDetailsRef}
              style={{ top: "150%" }}
            >
              <Link
                to={`/agent-account`}
                className="w-full"
                style={{ cursor: "pointer", padding: "0 10px" }}
                // to="/vendor/property/list"
                // onClick={handleLogoutHandle}
                // onClick={() => setLogOutPopup(true)}
              >
                <div
                  // to="/vendor/update"
                  className=" flex_align_center flex_gap_10 p_0"
                  style={{ margin: "7px 0" }}
                >
                  <span className="AccountDetails_dropdown">
                    <svg
                      className="m_0"
                      width="14"
                      height="15"
                      viewBox="0 0 14 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.75 14.25C1.3375 14.25 0.984375 14.1031 0.690625 13.8094C0.396875 13.5156 0.25 13.1625 0.25 12.75V2.25C0.25 1.8375 0.396875 1.48438 0.690625 1.19063C0.984375 0.896875 1.3375 0.75 1.75 0.75H7V2.25H1.75V12.75H7V14.25H1.75ZM10 11.25L8.96875 10.1625L10.8813 8.25H4.75V6.75H10.8813L8.96875 4.8375L10 3.75L13.75 7.5L10 11.25Z"
                        fill="#000"
                      />
                    </svg>
                  </span>
                  <div className="py-5">
                    <strong style={{ display: "block" }}>My Profile</strong>
                  </div>
                </div>
              </Link>
            </div>
          )}
        </div>
      </Link>

      {logOutPopup && (
        <div className="bg_back_drop_overlay">
          <div className="bg-white-div p_0">
            <div style={{ height: "150px" }}>
              {" "}
              <img src={logoutIcon} alt="logout image" />
            </div>
            <div className="p_15">
              {" "}
              <h4>Confirm Logout</h4>
              <span className="block mt-5">
                Are you sure you want to logout ?
              </span>
              <div className="mt-10 flex align_items_center flex_gap_5">
                <button
                  className="w-half no_logout_btn"
                  onClick={() => setLogOutPopup(false)}
                >
                  No
                </button>
                <button
                  className="w-half vendor_common_property"
                  // onClick={handleLogout}
                  onClick={handleLogoutHandle}
                >
                  Yes
                </button>
              </div>{" "}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default NewAgentAccountDetailDropdown;
